import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

interface OpenAnswerInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
  placeholder?: string;
  context?: string;
}

const DEFAULT_MAX_LENGTH = 2000;

export function OpenAnswerInput({
  value,
  onChange,
  disabled = false,
  maxLength = DEFAULT_MAX_LENGTH,
  placeholder = "Type your answer here...",
  context,
}: OpenAnswerInputProps) {
  const charCount = value.length;
  const isNearLimit = charCount > maxLength * 0.9;
  const isAtLimit = charCount >= maxLength;

  return (
    <div className="space-y-2">
      {context && (
        <p className="text-sm text-muted-foreground italic">{context}</p>
      )}
      <Textarea
        value={value}
        onChange={(e) => {
          const newValue = e.target.value;
          // Enforce max length
          if (newValue.length <= maxLength) {
            onChange(newValue);
          }
        }}
        disabled={disabled}
        placeholder={placeholder}
        className={cn(
          "min-h-[120px] resize-y",
          disabled && "bg-muted"
        )}
        rows={5}
      />
      <div
        className={cn(
          "text-xs text-right transition-colors",
          isAtLimit && "text-red-600 font-medium",
          isNearLimit && !isAtLimit && "text-amber-600",
          !isNearLimit && "text-muted-foreground"
        )}
      >
        {charCount.toLocaleString()} / {maxLength.toLocaleString()} characters
      </div>
    </div>
  );
}
